import React, {ReactElement, ReactNode, useEffect, useState} from "react";
import {Button, SvgIcon, Typography, useTheme} from "@mui/material";
import {StyledBoxColumn} from "../../shared/StyledComponents";
import {DIVIDER} from "../../shared/dimens";
import {ArrowBackIosNewOutlined} from "@mui/icons-material";

export type StudioAppTab = {
  key: string,
  text: string,
  iconType: typeof SvgIcon,
  disabled?: boolean,
}

export function StudioAppTabsContainer({tabs, onSelect, onBack, children, initialSelectedKey}: {
  tabs: StudioAppTab[],
  onSelect: (key: string) => void,
  onBack?: () => void,
  children: ReactNode,
  initialSelectedKey: string,
}): ReactElement {
  const theme = useTheme();
  const [selectedKey, setSelectedKey] = useState<string>();
  useEffect(() => {
    setSelectedKey(initialSelectedKey || tabs[0].key);
  }, [initialSelectedKey]);
  useEffect(() => {
    onSelect(selectedKey);
  }, [selectedKey]);
  return <div style={{width: "100%", height: "100%", overflow: "hidden", flexGrow: 1, display: "flex"}}>
    <div style={{
      width: 72,
      display: "flex",
      flexDirection: "column",
      background: theme.palette.background.paper,
      borderRight: DIVIDER,
    }}>
      {Boolean(onBack)
        ? <Button startIcon={<ArrowBackIosNewOutlined/>} onClick={onBack}>Back</Button>
        : null}
      {tabs.map(tab => <Button
        disabled={tab.disabled}
        onClick={() => setSelectedKey(tab.key)}
        variant={selectedKey === tab.key ? "contained" : null}
        color={"secondary"}
        style={{minWidth: 0, width: 72, height: 72, borderRadius: theme.shape.borderRadius}}>
        <StyledBoxColumn style={{width: "100%", alignItems: "center", gap: 4}}>
          <tab.iconType/>
          <Typography style={{fontSize: "80%"}}>{tab.text}</Typography>
        </StyledBoxColumn>
      </Button>)}
    </div>
    {children}
  </div>;
}